// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Single source of truth for the durable offline-queue identity. The writer
// (hole screen) and every reader (cached-snapshot overlays) must derive the
// exact same key, or offline writes become invisible to the overlay.

import { getActiveClaimSessionSync, getClaimClientIdSync } from './claimSession';

export type OfflineSubjectUser = { id?: string | null; token?: string | null } | null | undefined;

/**
 * Offline-queue subject key: signed-in users get `user:<id>`, guest scorers
 * with an active claim get `claim:<claimClientId>`, everyone else shares
 * `anonymous`.
 */
export const getOfflineSubjectKey = (user: OfflineSubjectUser): string => {
  if (user?.id) {
    return `user:${user.id}`;
  }
  if (!user?.token) {
    const claimSession = getActiveClaimSessionSync();
    const claimClientId = claimSession?.claimClientId ?? getClaimClientIdSync();
    if (claimSession && claimClientId) {
      return `claim:${claimClientId}`;
    }
  }
  return 'anonymous';
};
